import { render, staticRenderFns } from "./GoOnBussinessRequests.vue?vue&type=template&id=35e8acbe&scoped=true"
import script from "./GoOnBussinessRequests.vue?vue&type=script&lang=js"
export * from "./GoOnBussinessRequests.vue?vue&type=script&lang=js"
import style0 from "../../../../assets/css/layout/Request.css?vue&type=style&index=0&id=35e8acbe&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e8acbe",
  null
  
)

export default component.exports